import React from "react";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import { useCaptains } from "./hooks/useCaptains";
import CaptainDetailPage from "./pages/CaptainDetailPage/CaptainDetailPage";
import CaptainListPage from "./pages/CaptainListPage";
import Overview from "./pages/Overview/Overview";
import Datenschutz from "./pages/Datenschutz/Datenschutz";
import Impressum from "./pages/Impressum/Impressum";

const App: React.FC = () => {
    const { data: captains, isLoading } = useCaptains();

    if (isLoading) {
        return (
            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh", fontSize: "1.5rem" }}>
                Loading captains data...
            </div>
        );
    }

    return (
        <Router>
            <Routes>
                <Route path="/" element={<Overview />} />
                <Route path="/:captainName" element={<CaptainListPage />} />
                {captains.map((captain) => (
                    <Route
                        key={captain.route}
                        path={`${captain.route}/statistics`}
                        element={<CaptainDetailPage captain={captain} />}
                    />
                ))}
                <Route path="/impressum" element={<Impressum />} />
                <Route path="/datenschutz" element={<Datenschutz />} />
            </Routes>
        </Router>
    );
};

export default App;
